<div class="component-container base-data-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'technician-data.base-data-title' | translate"
      [tooltip]="'tooltips.technician-form.base-data' | translate"
      [showTooltip]="infoBubblesData?.showBaseDataInfo"
      tooltipStyleClass="base-data-tooltip"
      tooltipPosition="bottom"></app-section-header>
  </div>
  <form [formGroup]="technicianBaseDataFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="form-background">
      <ng-container
        *ngIf="
          isDecommissioningOfGridConnection &&
          changeConnectionType === changeConnectionTypes[0].value &&
          currentFlowType === installationFlowType.ChangeHouseConnection
        ">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align">{{ 'technician-data.form-fields.shutdown-dropdown' | translate }}</label>
          <p-dropdown [options]="shutdownReasonTypes" formControlName="shutDownReason" [readonly]="isReadOnly" placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + shutdownReasonKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + shutdownReasonKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows shut-down"
          *ngIf="technicianBaseDataFG.get('shutDownReason')?.value === 'other'">
          <div class="ui-g-5"></div>
          <input type="text" class="ui-input pInputText" formControlName="otherShutDownReason" pInputText [readonly]="isReadOnly" />
        </div>
      </ng-container>
      <ng-container *ngIf="showGenericBaseDataSection">
        <div
          *ngIf="currentFlowType === installationFlowType.ChangeHouseConnection && changeConnectionType === changeConnectionTypes[0].value">
          <div class="ui-g form-rows" *ngIf="!isDecommissioningOfGridConnection || changeConnectionType !== changeConnectionTypes[0].value">
            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
              *ngIf="technicianBaseDataFG.get('siteElectricityCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                (onChange)="selectSiteElectricity($event)"
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="siteElectricityCheckbox"
                label="{{ 'technician-data.form-fields.site-electricity-checkbox' | translate }}"></p-checkbox>
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding"
              *ngIf="technicianBaseDataFG.get('siteWaterCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                (onChange)="selectSiteWater($event)"
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="siteWaterCheckbox"
                label="{{ 'technician-data.form-fields.site-water-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>
          <div *ngIf="showPowerSection" class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-bottom-margin">
              <label for="power-connection-total-output" class="ui-g-5 field-label text-right-align">
                {{ 'technician-data.form-fields.total-output' | translate }}
              </label>
              <input
                [appNumber]="true"
                class="ui-input pInputText small-field-width"
                formControlName="totalOutput"
                [readonly]="isReadOnly"
                id="power-connection-total-output"
                maxlength="5"
                pInputText
                size="30" />
              <span class="field-unit-label">{{ allUnits.power }}</span>
            </div>
          </div>
          <ng-container *ngIf="showPowerSection">
            <div *ngFor="let device of specialDevices.controls; index as i" formArrayName="specialDevice">
              <div [formGroupName]="i" class="ui-g form-rows top-border">
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows no-padding">
                  <label class="ui-g-6 field-label text-right-align required" for="device">
                    {{ 'technician-data.form-fields.device' | translate }}
                  </label>
                  <p-dropdown
                    [options]="specialDeviceTypes"
                    formControlName="device"
                    [readonly]="isReadOnly"
                    id="device"
                    placeholder="-Select-">
                    <ng-template let-item pTemplate="selectedItem">
                      <span class="drop-item-label">
                        {{ 'lookup.' + specialDeviceTypeKey + '.options.' + item['value'] + '.name' | translate }}
                      </span>
                    </ng-template>
                    <ng-template let-option pTemplate="item">
                      <div class="drop-item">
                        <span class="drop-item-label">
                          {{ 'lookup.' + specialDeviceTypeKey + '.options.' + option['value'] + '.name' | translate }}
                        </span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>

                <div class="ui-g-7 ui-xl-7 ui-lg-7 ui-md-12 ui-sm-12 ui-xs-12 no-padding">
                  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
                    <label class="ui-g-5 field-label text-right-align required" for="power-connection-count">
                      {{ 'technician-data.form-fields.count' | translate }}
                    </label>
                    <input
                      [appNumber]="true"
                      class="ui-input pInputText small-field-width"
                      formControlName="count"
                      [readonly]="isReadOnly"
                      id="power-connection-count"
                      maxlength="5"
                      pInputText
                      size="30" />
                  </div>

                  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
                    <label class="ui-g-5 field-label text-right-align required" for="power-connection-power">
                      {{ 'technician-data.form-fields.power' | translate }}
                    </label>
                    <input
                      [appNumber]="true"
                      class="ui-input pInputText small-field-width"
                      formControlName="power"
                      id="power-connection-power"
                      maxlength="5"
                      pInputText
                      size="30"
                      [readonly]="isReadOnly" />
                    <span class="field-unit-label">{{ allUnits.power }}</span>
                  </div>
                </div>
                <div (click)="removeDevice(i)" *ngIf="!isReadOnly" class="pi pi-trash pointer-cursor ui-g-1"></div>
              </div>
            </div>
          </ng-container>
          <div *ngIf="!isReadOnly && this.showPowerSection" class="ui-g-12 add-button-row">
            <div class="empty-container"></div>
            <i (click)="addDevice()" class="pi pi-plus plus-icon" id="power-connection-add-consumer"></i>
            <label class="ui-g-5 field-label" for="power-connection-add-consumer">
              {{ 'technician-data.form-fields.special-consumers-button' | translate }}
            </label>
          </div>
          <div *ngIf="currentFlowType === installationFlowType.ChangeHouseConnection">
            <div *ngIf="showPowerSection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows base-data-heading">
                {{ 'personal-data.power' | translate }}
              </div>
            </div>
            <div *ngIf="showPowerSection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows top-border row-padding">
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
                <label class="ui-g-7 field-label text-right-align" for="base-data-tax_id">
                  {{ 'basic-profile.fields.tax_id' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="ui-input pInputText small-field-width"
                  formControlName="tax_id"
                  id="base-data-tax_id"
                  pInputText
                  size="30"
                  [readonly]="isReadOnly" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
                <label class="ui-g-7 field-label text-right-align" for="base_data_company-name">
                  {{ 'technician-data.form-fields.company-name' | translate }}
                </label>
                <input
                  class="ui-input pInputText small-field-width"
                  formControlName="company_name"
                  id="base_data_company-name"
                  pInputText
                  size="30"
                  type="text"
                  [readonly]="isReadOnly" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
                <label class="ui-g-7 field-label text-right-align" for="base-data_telephone">
                  {{ 'technician-data.form-fields.telephone' | translate }}
                </label>
                <input
                  [appNumber]="true"
                  class="ui-input pInputText small-field-width"
                  formControlName="telephone"
                  [readonly]="isReadOnly"
                  id="base-data_telephone"
                  pInputText
                  size="30" />
              </div>
            </div>

            <div *ngIf="showWaterSection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows base-data-heading">
                {{ 'personal-data.water' | translate }}
              </div>
            </div>
            <div *ngIf="showWaterSection" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label class="ui-g-5 field-label text-right-align" for="base-data-peak-flow">
                {{ 'technician-data.form-fields.peak-flow' | translate }}
              </label>
              <input
                [appNumber]="true"
                class="ui-input pInputText small-field-width"
                formControlName="peakFlow"
                id="base-data-peak-flow"
                maxlength="5"
                pInputText
                size="30"
                [readonly]="isReadOnly" />
              <span class="field-unit-label">{{ unitLabels.peakFlow }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="currentFormType.index < 2 || showTrenchLengthSection" class="ui-g form-rows">
          <div
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12"
            *ngIf="isTrenchLengthOver30 && technicianBaseDataFG.get('connectionLineCheckbox')">
            <label class="ui-g-5"></label>
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field"
              formControlName="connectionLineCheckbox"
              label="{{ 'technician-data.form-fields.connection-line-checkbox' | translate }}"></p-checkbox>
          </div>

          <div class="ui-g-12" *ngIf="isTrenchLengthFixed">
            <div class="ui-g-12 section-header">{{ 'technician-data.trench-length-title' | translate }}</div>
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="technicianBaseDataFG.get('cableLengthTotal')">
              <label
                class="ui-g-7 field-label text-right-align"
                [class.required]="isTrenchLengthFieldsRequired ? false : showField()"
                for="cable-length-total">
                {{ 'technician-data.form-fields.cable-length-total' | translate }}
              </label>
              <input
                [appNumber]="true"
                class="ui-input pInputText small-field-width"
                formControlName="cableLengthTotal"
                id="cable-length-total"
                pInputText
                size="30"
                [readonly]="isReadOnly" />
              <span class="unit-margin">{{ allUnits.length }}</span>
            </div>

            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="technicianBaseDataFG.get('cableLengthFixed')">
              <label
                class="ui-g-7 field-label text-right-align"
                [class.required]="isTrenchLengthFieldsRequired ? false : showField()"
                for="cable-length-fixed">
                {{ 'technician-data.form-fields.cable-length-fixed' | translate }}
              </label>
              <input
                [appNumber]="true"
                class="ui-input pInputText small-field-width"
                formControlName="cableLengthFixed"
                id="cable-length-fixed"
                pInputText
                size="30"
                [readonly]="isReadOnly" />
              <span class="unit-margin">{{ allUnits.length }}</span>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            technicianBaseDataFG.get('residentialUnits') &&
            currentFormType.index > 0 &&
            ((currentFlowType === installationFlowType.ChangeHouseConnection &&
              (changeConnectionType === changeConnectionTypes[1].value || changeConnectionType === changeConnectionTypes[2].value)) ||
              currentFlowType === installationFlowType.ConversionToGas)
          "
          class="ui-g form-rows">
          <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field"
              formControlName="residentialUnits"
              label="{{ 'technician-data.form-fields.residential-units' | translate }}"></p-checkbox>
          </div>
          <div
            *ngIf="showResidentialUnitCount && technicianBaseDataFG.get('residentialUnitsCount')"
            class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-6 field-label text-right-align" for="residential-units-count">
              {{ 'technician-data.form-fields.residential-units-count' | translate }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-field-width"
              formControlName="residentialUnitsCount"
              id="residential-units-count"
              pInputText
              size="30"
              [readonly]="isReadOnly" />
          </div>
          <div
            *ngIf="technicianBaseDataFG.get('reasonForReinforcement')"
            class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-6 field-label text-right-align required" for="reason-for-reinforcement">
              {{ 'technician-data.form-fields.reason-for-reinforcement' | translate }}
            </label>
            <input
              type="text"
              class="ui-input pInputText"
              formControlName="reasonForReinforcement"
              id="reason-for-reinforcement"
              pInputText
              size="30"
              [readonly]="isReadOnly" />
          </div>
        </div>
        <div
          *ngIf="
            technicianBaseDataFG.get('business') &&
            currentFormType.index > 0 &&
            ((currentFlowType === installationFlowType.ChangeHouseConnection &&
              (changeConnectionType === changeConnectionTypes[1].value || changeConnectionType === changeConnectionTypes[2].value)) ||
              currentFlowType === installationFlowType.ConversionToGas)
          "
          class="ui-g form-rows">
          <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field"
              formControlName="business"
              label="{{ 'technician-data.form-fields.business' | translate }}"></p-checkbox>
          </div>
          <div
            *ngIf="showCommercialUnitCount && technicianBaseDataFG.get('commercialUnitsCount')"
            class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-6 field-label text-right-align" for="commercial-units-count">
              {{ 'technician-data.form-fields.commercial-units-count' | translate }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-field-width"
              formControlName="commercialUnitsCount"
              id="commercial-units-count"
              pInputText
              size="30"
              [readonly]="isReadOnly" />
          </div>
        </div>
        <div
          *ngIf="
            currentFlowType !== installationFlowType.ConversionToGas && currentFlowType !== installationFlowType.ChangeHouseConnection
          ">
          <div *ngIf="technicianBaseDataFG.get('publicationInstitutionCheckbox')" class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="publicationInstitutionCheckbox"
                id="publication-institution"
                label="{{ 'technician-data.form-fields.publication-institution-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>

          <div *ngIf="technicianBaseDataFG.get('earthworkContributionCheckbox') && currentFormType.index < 2" class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="earthworkContributionCheckbox"
                label="{{ 'technician-data.form-fields.earthwork-contribution-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>

          <div *ngIf="currentFlowType === installationFlowType.MainsConnection" class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="technicianBaseDataFG.get('generatingPlantCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="generatingPlantCheckbox"
                label="{{ 'technician-data.form-fields.generating-plant-checkbox' | translate }}"></p-checkbox>
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-padding"
              *ngIf="technicianBaseDataFG.get('plannedOutputCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="plannedOutputCheckbox"
                label="{{ 'technician-data.form-fields.planned-output-checkbox' | translate }}"></p-checkbox>
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-padding"
              *ngIf="technicianBaseDataFG.get('telecomConnectionCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="telecomConnectionCheckbox"
                label="{{ 'technician-data.form-fields.telecom-connection-checkbox' | translate }}"></p-checkbox>
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-padding"
              *ngIf="technicianBaseDataFG.get('widebandConnectionCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="widebandConnectionCheckbox"
                label="{{ 'technician-data.form-fields.wideband-connection-checkbox' | translate }}"></p-checkbox>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showTempConnectionsInfo">
              <label class="ui-g-5 extra-info">{{ 'technician-data.base-data-temp-connection-info' | translate }}</label>
            </div>
          </div>

          <div
            class="ui-g form-rows"
            *ngIf="technicianBaseDataFG.get('interestInFibreCheckbox') || technicianBaseDataFG.get('siteWaterCheckbox')">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="technicianBaseDataFG.get('interestInFibreCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="interestInFibreCheckbox"
                label="{{ 'technician-data.form-fields.interestin-fibre-checkbox' | translate }}"></p-checkbox>
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-padding water-site-section"
              *ngIf="technicianBaseDataFG.get('siteWaterCheckbox')">
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                [disabled]="!disableSiteWater && !isNewDevArea"
                class="ui-g-5 checkbox-field"
                (onChange)="checkJurisdictionAvailability($event)"
                formControlName="siteWaterCheckbox"
                label="{{ 'technician-data.form-fields.site-water-checkbox' | translate }}"></p-checkbox>
              <label *ngIf="showJurisdictionNotice || technicianBaseDataFG.get('siteWaterCheckbox').value">
                {{ 'technician-data.notification-text' | translate }}
              </label>
            </div>
          </div>
          <div
            class="ui-g form-rows"
            *ngIf="technicianBaseDataFG.get('feedInSystemCheckbox') || technicianBaseDataFG.get('wallboxCheckbox')">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="technicianBaseDataFG.get('feedInSystemCheckbox')">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="feedInSystemCheckbox"
                label="{{ 'technician-data.form-fields.feedin-system-checkbox' | translate }}"></p-checkbox>
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-padding water-site-section"
              *ngIf="technicianBaseDataFG.get('wallboxCheckbox')">
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="ui-g-5 checkbox-field"
                formControlName="wallboxCheckbox"
                label="{{ 'technician-data.form-fields.wallbox-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>
          <div class="ui-g form-rows" *ngIf="technicianBaseDataFG.get('siteElectricityCheckbox')">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
              <label class="ui-g-5"></label>
              <p-checkbox
                binary="true"
                [readonly]="isReadOnly"
                class="checkbox-field"
                formControlName="siteElectricityCheckbox"
                label="{{ 'technician-data.form-fields.site-electricity-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>
        </div>
        <div
          *ngIf="technicianBaseDataFG.get('siteElectricityCheckbox')?.value"
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 ordnance-warning">
          <i class="pi pi-exclamation-circle info-icon"></i>
          <span [innerHTML]="'technician-data.site-electricity-notification' | translate"></span>
        </div>

        <div *ngIf="showOtherInquiriesSection" class="ui-g-12">
          <div class="ui-g-12 section-header">{{ 'technician-data.other-inquiries-title' | translate }}</div>
          <div class="ui-g-12 other-inquiries-row" *ngIf="technicianBaseDataFG.get('swsWithBasement')">
            <label class="ui-g field-label required" for="cable-length-fixed">
              {{ 'technician-data.form-fields.with-basement' | translate }}
            </label>
            <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-6 ui-xs-12 radio-button-group">
              <p-radioButton
                formControlName="swsWithBasement"
                label="{{ 'yes-button-label' | translate }}"
                name="with-basement"
                value="1"></p-radioButton>
              <p-radioButton
                formControlName="swsWithBasement"
                label="{{ 'no-button-label' | translate }}"
                name="with-basement"
                value="0"></p-radioButton>
            </div>
          </div>
          <ng-container *ngIf="showField()">
            <div class="ui-g-12 other-inquiries-row">
              <label class="ui-g field-label required" for="cable-length-fixed">
                {{ 'technician-data.form-fields.connection-lead-basement' | translate }}
              </label>
              <div
                class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-6 ui-xs-12 radio-button-group"
                *ngIf="technicianBaseDataFG.get('swsConLeadBasement')">
                <p-radioButton
                  formControlName="swsConLeadBasement"
                  label="{{ 'yes-button-label' | translate }}"
                  name="con-lead-basement"
                  value="1"></p-radioButton>
                <p-radioButton
                  formControlName="swsConLeadBasement"
                  label="{{ 'no-button-label' | translate }}"
                  name="con-lead-basement"
                  value="0"></p-radioButton>
              </div>
            </div>
            <div class="ui-g-12 other-inquiries-row">
              <label class="ui-g field-label required" for="cable-length-fixed">
                {{ 'technician-data.form-fields.waterproof-basement' | translate }}
              </label>
              <div
                class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-6 ui-xs-12 radio-button-group"
                *ngIf="technicianBaseDataFG.get('swsWaterProofBasement')">
                <p-radioButton
                  formControlName="swsWaterProofBasement"
                  label="{{ 'yes-button-label' | translate }}"
                  name="water-proof-basement"
                  value="1"></p-radioButton>
                <p-radioButton
                  formControlName="swsWaterProofBasement"
                  label="{{ 'no-button-label' | translate }}"
                  name="water-proof-basement"
                  value="0"></p-radioButton>
              </div>
            </div>
            <div class="ui-g-12 other-inquiries-row">
              <label class="ui-g field-label required" for="cable-length-fixed">
                {{ 'technician-data.form-fields.connection-lead-main-building' | translate }}
              </label>
              <div
                class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-6 ui-xs-12 radio-button-group"
                *ngIf="technicianBaseDataFG.get('swsConLeadMainBuilding')">
                <p-radioButton
                  formControlName="swsConLeadMainBuilding"
                  label="{{ 'yes-button-label' | translate }}"
                  name="con-lead-main-building"
                  value="1"></p-radioButton>
                <p-radioButton
                  formControlName="swsConLeadMainBuilding"
                  label="{{ 'no-button-label' | translate }}"
                  name="con-lead-main-building"
                  value="0"></p-radioButton>
              </div>
            </div>
          </ng-container>
          <div class="ui-g-12 other-inquiries-row">
            <label class="ui-g field-label required" for="cable-length-fixed">
              {{ 'technician-data.form-fields.third-party-profit-affected' | translate }}
            </label>
            <div
              class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-6 ui-xs-12 radio-button-group"
              *ngIf="technicianBaseDataFG.get('swsThirdPartyAffected')">
              <p-radioButton
                formControlName="swsThirdPartyAffected"
                label="{{ 'yes-button-label' | translate }}"
                name="third-party-affected"
                value="1"></p-radioButton>
              <p-radioButton
                formControlName="swsThirdPartyAffected"
                label="{{ 'no-button-label' | translate }}"
                name="third-party-affected"
                value="0"></p-radioButton>
            </div>
          </div>
          <div class="ui-g-12 other-inquiries-row" *ngIf="technicianBaseDataFG.get('swsPlotSize')">
            <label class="ui-g field-label" [class.required]="showField()" for="plot-size">
              {{ 'technician-data.form-fields.plot-size' | translate }}
            </label>
            <span class="ui-g plot-size-data">
              <p-inputNumber
                locale="de-DE"
                [useGrouping]="false"
                class="ui-input pInputText small-field-width"
                formControlName="swsPlotSize"
                id="plot-size"></p-inputNumber>
              <span class="unit-margin">{{ allUnits.area }}</span>
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showHALengthsSection">
        <div *ngIf="currentFlowType === installationFlowType.MainsConnection" class="ui-g ha-length-section">
          <div class="ui-g bottom-padding" *ngIf="technicianBaseDataFG.get('haLengths')">
            <label class="ui-g field-label required" for="ha-length">
              {{ 'technician-data.form-fields.ha-lengths-on-private-land' | translate }}
            </label>
            <span class="ui-g ha-length-data">
              <input
                appFloatNumber="2"
                class="ui-input pInputText small-field-width"
                formControlName="haLengths"
                id="ha-length"
                pInputText
                size="30"
                [readonly]="isReadOnly" />
              <span class="unit-margin">{{ allUnits.length }}</span>
            </span>
          </div>

          <div *ngIf="technicianBaseDataFG.get('basementAvailable')" class="ui-g bottom-padding">
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field"
              formControlName="basementAvailable"
              label="{{ 'technician-data.form-fields.basement-available-checkbox' | translate }}"></p-checkbox>
          </div>

          <div *ngIf="technicianBaseDataFG.get('houseConnectionRoomAvailable')" class="ui-g">
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field"
              formControlName="houseConnectionRoomAvailable"
              label="{{ 'technician-data.form-fields.house-connection-room-checkbox' | translate }}"></p-checkbox>
          </div>
        </div>
      </ng-container>

      <div *ngIf="showConnectionOptions" class="connections">
        <div>
          <label for="pressAccordingToTab" class="rb-label">{{ 'technician-data.press-connections' | translate }}</label>
          <p-radioButton
            name="connectionsType"
            [value]="connectionTypes.pressAccordingToTab"
            inputId="pressAccordingToTab"
            formControlName="connectionsType"
            [disabled]="isReadOnly"></p-radioButton>
        </div>

        <div>
          <label for="weldedConnections" class="rb-label">{{ 'technician-data.welded-connections' | translate }}</label>
          <p-radioButton
            name="connectionsType"
            [value]="connectionTypes.weldedConnections"
            inputId="weldedConnections"
            formControlName="connectionsType"
            [disabled]="isReadOnly"></p-radioButton>
        </div>
      </div>
    </div>
  </form>
</div>
<app-loader *ngIf="isLoading"></app-loader>
